import {useEffect,useRef} from 'react'
import "./infoPopUp.scss"
import { useTranslation } from 'react-i18next'

export default function InfoPopUp(props) {
    const popupRef = useRef();
    const {t} = useTranslation(["common"]);

    useEffect(() => {
        const clickOutsideContent = (e) => {
            if (e.target === popupRef.current) {
                props.setShow(false);
            }
        };
        window.addEventListener('click', clickOutsideContent);
        return () => {
            window.removeEventListener('click', clickOutsideContent);
        };
    }, [props]);

  return (
    <div className={`popup ${props.show&& 'active'}`}
    ref={popupRef} 
    >
        <div className="popup_content">
            
            <div className="header">
                <h2>{t("PopTitle")}</h2>
                <svg onClick={() => props.setShow(false)} className='x' xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/></svg>    
            </div>
          
            <div className="body">
            {t("PopInfo")}       
                 </div>
        </div>

    </div>
  )
}
